import axios from "axios";
import dayjs from "dayjs";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch {
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d && typeof d === "object" && d.message) return d.message;
  if (d && typeof d === "object") return d.code || JSON.stringify(d);
  return e?.message || "Something went wrong";
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const inr0 = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const fmtDate = (s) => (s ? dayjs(s).format("DD MMM YYYY") : "—");

export async function download(path, fallbackName = "download") {
  const res = await api.get(path, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^";]+)"?/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m ? m[1] : fallbackName;
  a.click();
  URL.revokeObjectURL(url);
}

export function Money({ value, className = "", testid }) {
  return (
    <span data-testid={testid} className={`num text-[#0D4F4A] ${className}`}>
      {inr(value)}
    </span>
  );
}

export const DOC_TYPE_LABELS = {
  tax_invoice: "Tax Invoice",
  bill_of_supply: "Bill of Supply",
  proforma: "Proforma Invoice",
  receipt: "Receipt Voucher",
  credit_note: "Credit Note",
  debit_note: "Debit Note",
};

export const STATUS_COLORS = {

  draft: "bg-slate-100 text-slate-600 border-slate-300",
  issued: "bg-sky-50 text-sky-700 border-sky-200",
  partial: "bg-amber-50 text-amber-700 border-amber-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-50 text-red-600 border-red-200",
  Enquiry: "bg-slate-100 text-slate-600 border-slate-300",
  Quotation: "bg-violet-50 text-violet-700 border-violet-200",
  Confirmed: "bg-sky-50 text-sky-700 border-sky-200",
  "Partially Paid": "bg-amber-50 text-amber-700 border-amber-200",
  "Fully Paid": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Travel Completed": "bg-teal-50 text-teal-700 border-teal-200",
  Cancelled: "bg-red-50 text-red-600 border-red-200",
  Refunded: "bg-rose-50 text-rose-600 border-rose-200",
  Draft: "bg-slate-100 text-slate-600 border-slate-300",
  Sent: "bg-sky-50 text-sky-700 border-sky-200",
  Accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rejected: "bg-red-50 text-red-600 border-red-200",
  Converted: "bg-teal-50 text-teal-700 border-teal-200",
  open: "bg-emerald-50 text-emerald-700 border-emerald-200",
  under_review: "bg-amber-50 text-amber-700 border-amber-200",
  reviewed: "bg-sky-50 text-sky-700 border-sky-200",
  locked: "bg-red-50 text-red-600 border-red-200",
};
